<template>
    <div id="aprication">
        <div class="header-div">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="header-div" style="text-align: right">
            <div style="float: right">
                <el-popconfirm title="确定删除吗？" @onConfirm="batchRemove()">
                    <el-button size="mini" slot="reference" v-if="$hasPerm('sys:log:remove')" type="danger"
                               style=";background-color: rgb(244, 74, 74);color: white">批量<i class="el-icon-delete"></i>
                    </el-button>
                </el-popconfirm>
            </div>
            <div style="float: right">
                <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                        class="el-icon-search"></i></el-button>
            </div>
            <div style="float: right">
                <el-input
                        class="loginput"
                        placeholder="请输入用户名"
                        v-model="username"
                        clearable>
                </el-input>
            </div>
            <div style="float: right">
                <el-input
                        class="loginput"
                        placeholder="操作/参数"
                        v-model="operation"
                        clearable>
                </el-input>
            </div>
        </div>
        <el-table
                :data="tableData"
                border
                size="medium"
                style="width: 100%"
                ref="multipleTable"
                height="420"
                @selection-change="selectionLineChangeHandle"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="用户ID：">
                            <span>{{ props.row.userId }}</span>
                        </el-form-item>
                        <el-form-item label="用户名称：">
                            <span>{{ props.row.username }}</span>
                        </el-form-item>
                        <el-form-item label="操作：">
                            <span>{{ props.row.operation }}</span>
                        </el-form-item>
                        <el-form-item label="方法：">
                            <span>{{ props.row.method }}</span>
                        </el-form-item>
                        <el-form-item label="参数：">
                            <span>{{ props.row.params }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column min-width="100" :show-overflow-tooltip="true" prop="userId" label="用户ID"
                             style="width: 10%"></el-table-column>
            <el-table-column min-width="121" prop="username" :show-overflow-tooltip="true" label="用户名称"></el-table-column>
            <el-table-column min-width="150" :show-overflow-tooltip="true" prop="operation"
                             label="操作"></el-table-column>
            <el-table-column width="90" prop="time" label="用时(毫秒)"></el-table-column>
            <el-table-column min-width="100" :show-overflow-tooltip="true" prop="method" label="方法"></el-table-column>
            <el-table-column min-width="150" :show-overflow-tooltip="true" prop="params" label="参数"></el-table-column>
            <el-table-column width="100" prop="ip" label="IP地址"></el-table-column>
            <el-table-column width="160" prop="gmtCreate" label="创建时间"></el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
                        <el-button size="mini" slot="reference" v-if="$hasPerm('sys:log:remove')" type="danger">删除<i
                                class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dataOnLineListSelections: [],
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                username: '',
                operation: '',
                tableData: []
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/common/log/list'),
                    method: 'get',
                    params: this.$httpTAG.adornParams({
                        'offset': this.offset,
                        'limit': this.pageSize,
                        username: this.username,
                        operation: this.operation
                    })
                }).then(r => {
                    this.tableData = r.data.data.rows;
                    this.total = r.data.data.total;
                }).finally(r => {})
            },
            selectionLineChangeHandle(val) {
                this.dataOnLineListSelections = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            //时间格式化
            dateFormat: function (row, column) {
                let date = row[column.property];
                if (date == 1) { return '是' } 
                if (date == 0) { return '否' } 
                return date;
            },
            handleDelete(index, row) {
                let id = row.id;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/common/log/remove'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {})
            },
            batchRemove() {
                if (this.dataOnLineListSelections.length == 0) {
                    this.$message({ // 失败
                        type: 'warning',
                        message: "请选择要删除的数据"
                    })
                    return false;
                }
                let ids = [];
                for (let i = 0; i < this.dataOnLineListSelections.length; i++) {
                    ids.push(this.dataOnLineListSelections[i].id);
                }

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/common/log/batchRemove'),
                    method: 'post',
                    data: ids
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange(1);
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {})
            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 10px;
        float: left;
        width: 50%;
    }

    .loginput >>> .el-input__inner {
        height: 28px;
        border-radius: 0px;
        width: 200px;
    }

    .loginput >>> .el-input__suffix {
        top: -5px;
    }


    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        margin-left: 5%;
        width: 100%;
    }
</style>
